export default __webpack_public_path__ + "media/images/images/jvqmap/marker/blue-e89b1e5c31b65e9c68bc5ae21cc6a448.png";